import { render, staticRenderFns } from "./RichTextEdit.vue?vue&type=template&id=12ff2282"
import script from "./RichTextEdit.vue?vue&type=script&lang=js"
export * from "./RichTextEdit.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RichTextEdit.vue?vue&type=style&index=1&id=12ff2282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports